module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0728.d48cff17.jpg";